<ng-container *transloco="let t">
  <div class="row mt-3">
    <div class="col-12">
      <h3 class="text-secondary">
        <lucide-icon [img]="icons.host"></lucide-icon>
        Organisateur
      </h3>
    </div>
  </div>

  @if (host()?.description) {
    <div class="row my-2">
      <div class="col-12 ml-description">
        {{ host()?.description }}
      </div>
    </div>
  }

  <div class="row">
    <div class="col-12 my-2 links">
      @if (host()?.webUrl) {
        <a [href]="host()?.webUrl"
           target="_blank"
           class="me-3"
           rel="noopener noreferrer">
          {{ socialLabels.web }}
          <lucide-icon [img]="icons.externalLink"></lucide-icon>
        </a>
      }
      @if (host()?.fbUrl) {
        <a [href]="host()?.fbUrl"
           target="_blank"
           class="me-3"
           rel="noopener noreferrer">
          {{ socialLabels.fb }}
          <lucide-icon [img]="icons.externalLink"></lucide-icon>
        </a>
      }
      @if (host()?.igUrl) {
        <a [href]="host()?.igUrl"
           target="_blank"
           class="me-3"
           rel="noopener noreferrer">
          {{ socialLabels.ig }}
          <lucide-icon [img]="icons.externalLink"></lucide-icon>
        </a>
      }

      <a [routerLink]="hostUrl()" class="me-3">
        Profil
        <lucide-icon [img]="icons.host"></lucide-icon>
      </a>
    </div>
  </div>

  @if (showMessaging()) {
    <div class="row my-2">
      <div class="col-12">
        <button type="button" class="btn btn-link text-start" (click)="toggleShowContact()">
          Écrire un message
          <lucide-icon [img]="icons?.message"></lucide-icon>
        </button>
      </div>
    </div>
  }

  <section [appScrollTarget]="SECTION_SEND_MESSAGE">
    @if (showContact()) {
      <app-host-contact-form
        [host]="activity()?.mainHost"
        [placeholder]="{subject: activity()?.title ?? null }"
        [isPreview]="isPreview()"
        (cancelled)="toggleShowContact()">
      </app-host-contact-form>
    }
  </section>
</ng-container>
